export const environment = {
  contextRoot: '{{CONTEXT_ROOT}}/',
  production: false,
  isPublished: true,
  disableSessionManagement: false,
  parentProject: 'kofi',
  redirectPath: '/kofi',
  externalUrl: '{{EXTERNAL_URL}}',
  name: 'dev',
  dateBetPG: '2024-07-25'
};
